module.exports = __webpack_public_path__ + "img/img1.01470943.svg";